import { render, staticRenderFns } from "./listMeals.vue?vue&type=template&id=01d57724&"
import script from "./listMeals.vue?vue&type=script&lang=js&"
export * from "./listMeals.vue?vue&type=script&lang=js&"
import style0 from "./listMeals.vue?vue&type=style&index=0&script=css&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports